import GuestsInput from "components/HeroSearchForm/GuestsInput";
import StayDatesRangeInput from "components/HeroSearchForm/StayDatesRangeInput";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { authGet, authJsonPost, getUrl } from "functions/BaseAxios";
import { cropAddress } from "functions/common";
import { currency, roundNumber } from "functions/redux/general/action";
import { detailTrip } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import { getFullCreds, LOGIN_FALSE } from "functions/redux/user/action";
import useWindowSize from "hooks/useWindowResize";
import i18n from "i18n/config";
import moment from 'moment-timezone'
import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import DocIframe from "./DocIframe";
import ModalPhotos from "./ModalPhotos";
import { Helmet } from "react-helmet";
import { getCommissionSetting } from "functions/redux/country/action";
import Modal from "./Modal";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Loader from "react-loader-spinner";
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { getStripe } from "utils/stripeSecurity";
import DetailSkeleton from "components/Skeleton/DetailSkeleton";
import { useHistory } from "react-router";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ncNanoId from "utils/ncNanoId";
import OtherTripCard from "./OtherTripCard";
import { useTranslation } from "react-i18next";
import NcModal from "shared/NcModal/NcModal";
import { getAnswerUser, getLoadingQuestion, getQuestionTrip, getShowItem, getTextQuestion, updateLoadingQuestion, updateShowItem, updateTextQuestion } from "functions/redux/question/action";
import ReactTextareaAutosize from "react-textarea-autosize";
import NcDropDown from "shared/NcDropDown/NcDropDown";
import toHumanDate from "utils/DateChange";

const ListingDetail: FC<{ id: any }> = ({ id }) => {
    const dispatch = useDispatch();

    const { listing, user, countriesReducer, questionReducer } = useSelector((state: RootStore) => state);

    const [isOpen, setIsOpen] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [openStripe, setOpenStripe] = React.useState(false);
    const [, setopenQuestion] = React.useState(false);
    const [openFormMobile, setOpenFormMobile] = React.useState(false);
    const [result, setResult] = React.useState<any>();

    const [confimationModal, setConfirmationModal] = React.useState(false);
    const [paymentMethodModal, setPaymentMethodModal] = React.useState(false);
    const [openFocusIndex, setOpenFocusIndex] = React.useState(0);
    const [smallLuggage, setSmallLuggage] = React.useState(0);
    const [underTwoYears, setUnderTwoYears] = React.useState(0);
    const [underTwelve, setUnderTwelve] = React.useState(0);
    const [adult, setAdult] = React.useState(0);
    const [maxGuest, setMaxGuest] = useState(100);
    const [guest, setGuest] = useState(100);
    const [bigLuggage, setBigLuggage] = React.useState(0);
    const [isTerm, setIsTerm] = React.useState(false);
    const [isCancel, setisCancel] = React.useState(false);
    const windowSize = useWindowSize();
    const handleCloseModal = () => setIsOpen(false);
    const handleOpenModal = (index: number) => {
        setIsOpen(true);
        setOpenFocusIndex(index);
    };
    const { t } = useTranslation();

    const [maxAdult, setMaxAdult] = useState(0);
    const [maxUnder, setMaxUnder] = useState(0);
    const [maxTwelve, setMaxTwelve] = useState(0);

    const [clientSecret] = React.useState('');
    const [addSlot, setAddSlot] = React.useState<any>(null);
    const [selectedServices, setSelectedServices] = React.useState(listing.detailTrip?.productService !== undefined ? listing.detailTrip?.productService : []);
    const [stripeOptions, setStripeOptions] = React.useState({ clientSecret: clientSecret });
    const stripePromise = React.useMemo(() => {
        if (!openStripe) return null;
        return getStripe();
    }, [openStripe]);
    const history = useHistory();
    React.useEffect(() => {
        updateLoadingQuestion(true);
        if (countriesReducer.commissionSetting == null) {
            dispatch(getCommissionSetting());
        }

        updateShowItem(0);

        if (user.credential == null) {
            dispatch(getFullCreds());
        }
        if (((listing.detailTrip != null && listing.detailTrip?.id !== id) || listing.detailTrip == null) && user != null) {
            dispatch(detailTrip(id, user.credential));
            dispatch(getQuestionTrip(id, 0))
            // dispatch(getAnswerUser(id))
        }


    }, [id]);


    // useEffect(() => {
    //     setAdult(0);
    //     setUnderTwelve(0);
    //     setUnderTwoYears(0);
    // }, [addSlot])


    React.useEffect(() => {
        if (listing?.detailTrip) {
            if (listing?.detailTrip?.isOpenTrip) {
                setMaxGuest(addSlot - underTwelve - underTwoYears - adult - 1)
                setMaxAdult(addSlot - (underTwelve + underTwoYears));
                setMaxTwelve(addSlot - (underTwoYears + adult));
                setMaxUnder(addSlot - (adult + underTwelve))
            } else {
                let guest = (addSlot + 1) * listing.detailTrip.maxGuest;

                setGuest(guest);
                setMaxGuest((guest) - (underTwelve + underTwoYears + adult) - 1);
                setMaxAdult(guest - (underTwelve + underTwoYears));
                setMaxTwelve(guest - (underTwoYears + adult));
                setMaxUnder(guest - (adult + underTwelve))
            }
        }

    }, [underTwoYears, underTwelve, adult, addSlot, maxGuest, listing.detailTrip])


    React.useEffect(() => {
        setUnderTwelve(0);
        setUnderTwoYears(0);
        setAdult(0);
        setBigLuggage(0);
        setSmallLuggage(0);
    }, [addSlot])


    React.useEffect(() => {
        if ((addSlot === 0 && listing.detailTrip?.isOpenTrip) || (listing.detailTrip?.addSlotPrice > 0)) {
            setAddSlot(listing.detailTrip?.isOpenTrip ? 1 : 0);
        }

    }, [listing, listing.detailTrip])


    // if ((addSlot === 0 && listing.detailTrip?.isOpenTrip) || (addSlot !== 0 && !listing.detailTrip?.isOpenTrip)) {
    //     setAddSlot(listing.detailTrip?.isOpenTrip ? 1 : 0);
    // }
    const [selectedDate, setSelectedDate] = React.useState<DateRage>({
        startDate: listing.detailTrip ? (moment()).tz(listing.detailTrip.timezone) : null,
        endDate: listing.detailTrip ? (moment().add(2, "days")).tz(listing.detailTrip.timezone) : null,
    });


    if (openFormMobile) {
        document.getElementById('footer')?.classList.add('hidden');
        document.getElementById('footer')?.classList.add('md:block');
    } else {
        document.getElementById('footer')?.classList.remove('hidden');
        document.getElementById('footer')?.classList.remove('md:block');
    }

    if (listing?.detailTrip?.isOpenTrip == 1) {
        let dataClas = document.getElementsByClassName('clearDate');
        for (let index = 0; index < dataClas.length; index++) {
            dataClas[index].classList.add('hidden');

        }

    }

    const getDays = () => {
        if (selectedDate.startDate == null) {
            return 0;
        }
        let diff = selectedDate.endDate?.diff(selectedDate.startDate, 'days') ?? 0;
        diff = selectedDate.endDate == null ? 1 : diff + 1
        return diff ?? 0;
    };
    const getBasicPrice = () => {
        return listing.detailTrip.isOpenTrip == 1
            ? addSlot * parseFloat(listing.detailTrip.totalPrice)
            : addSlot * parseFloat(listing.detailTrip.addSlotPrice == 0 ? listing.detailTrip.totalPrice : listing.detailTrip.addSlotPrice) + parseFloat(listing.detailTrip.totalPrice);
    };

    const getSubTotal = () => {
        const total =
            listing.detailTrip.isOpenTrip == 1
                ? addSlot * parseFloat(listing.detailTrip.totalPrice)
                : (addSlot * parseFloat(listing.detailTrip.addSlotPrice == 0 ? listing.detailTrip.totalPrice : listing.detailTrip.addSlotPrice) + parseFloat(listing.detailTrip.totalPrice)) *
                getDays();
        return roundNumber(total);
    };

    const getServiceFee = () => {
        let total = 0;
        for (let index = 0; index < Object.keys(selectedServices).length; index++) {
            const element = selectedServices[index];
            if (element) {
                total += (element.qty ?? 0) * element.price;
            }
        }
        return roundNumber(total);
    };

    let priceDisc = 0;
    const addToDiscount = (disc: any) => {
        priceDisc += disc;
    };

    const bottomPrice = () => {
        let tripDisc = 0;
        if ((listing.detailTrip.isOpenTrip) === true) {
            const prc = addSlot * parseFloat(listing.detailTrip.totalPrice);
            const fee = addSlot * parseFloat(listing.detailTrip.feeAmount);
            tripDisc = prc - fee;
        } else {
            tripDisc = parseFloat(listing.detailTrip.feeAmount);
            let price = (addSlot * parseFloat(listing.detailTrip.addSlotPrice == 0 ? listing.detailTrip.totalPrice : listing.detailTrip.addSlotPrice) +
                (parseFloat(listing.detailTrip.totalPrice)) *
                getDays());
            let fee = (addSlot * parseFloat(listing.detailTrip.addPriceFeeAmount) +
                (parseFloat(listing.detailTrip.feeAmount)) *
                getDays());

            // let price = (addSlot * parseFloat(listing.detailTrip.addSlotPrice)) +
            //     (addSlot * parseFloat(listing.detailTrip.totalPrice));
            // let fee = (addSlot * parseFloat(listing.detailTrip.addPriceFeeAmount)) +
            //     (addSlot * parseFloat(listing.detailTrip.feeAmount));
            tripDisc = price - fee;
        }
        return roundNumber(tripDisc + priceDisc);
    };
    const getTotal = () => {
        const total = parseFloat(getSubTotal()) + parseFloat(getServiceFee().toString());
        return roundNumber(total);
    };


    const getFeePlatform = () => {
        if (countriesReducer.commissionSetting != null) {
            const type = countriesReducer.commissionSetting.isCustomerFeePercent;
            const fee = countriesReducer.commissionSetting.customerFee;
            const comm = getCommission(type, fee, bottomPrice());
            return comm;
        }
        return '0';
    };


    const getCommission = (type: any, fee: any, amount: any) => {
        const feePrc = type === 1 ? (fee / 100) * amount : fee;
        return roundNumber(feePrc);
    };

    const getDiscount = () => {

        if (countriesReducer.commissionSetting != null) {
            const type = countriesReducer.commissionSetting.isCustomerFeePercent;
            const fee = countriesReducer.commissionSetting.customerFee;
            return (
                parseFloat(getCommission(type, fee, getTotal())) -
                parseFloat(getCommission(type, fee, bottomPrice()))
            ).toFixed(2);
        }
        return '0';
    };


    const getFinalPrice = () => {
        const final =
            parseFloat(getTotal()) +
            parseFloat(getFeePlatform()) -
            parseFloat(getDiscount());
        return final ? roundNumber(final) : 0;
    };



    const reserve = async () => {

        setSubmitting(true);
        var data = {
            productId: listing.detailTrip.id,
            totalPrice: getFinalPrice(),
            price: listing.detailTrip.totalPrice,
            qty: listing.detailTrip.isOpenTrip === true ? addSlot : getDays(),
            additional: selectedServices,
            startDate: selectedDate.startDate?.format("Y-MM-DD"),
            endDate: selectedDate.endDate?.format('Y-MM-DD'),
            addSlotPrice: listing.detailTrip.addSlotPrice,
            addSlotQty: addSlot,
            billedFeeAmount: getFeePlatform(),
            smallLuggage: smallLuggage,
            bigLuggage: bigLuggage,
            underTwelve: underTwelve,
            underTwoYears: underTwoYears,
            adult: adult,
            discount: getDiscount(),
        };

        var checkOut = await authJsonPost(
            data,
            'auth/booking-checkout',
        );
        setSubmitting(false);
        if (checkOut.code === 200) {
            setResult(checkOut.payload.data);
            setConfirmationModal(false);
            // if (listing.detailTrip.isOpenTrip) {
            //     setPaymentMethodModal(true);
            // } else {
            // }

            history.push(`/booking-detail?id=${checkOut.payload.data.id}`)

        }

    }

    const goWithTransfer = async () => {
        if (result !== undefined && result != null) {
            setSubmitting(true);
            var id = result['id'];
            var checkOut = await authJsonPost(
                { id },
                'auth/manual-transfer',
            );
            setSubmitting(false);
            if (checkOut.code === 200) {
                setPaymentMethodModal(false);
                history.push(`/booking-detail?id=${id}`)
            }
        }
    }

    const renderSection2 = () => {
        return (
            <div className="listingSection__wrap">
                <h2 className="text-2xl font-semibold">Information</h2>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                <div className="text-neutral-6000 dark:text-neutral-300">
                    <span>
                        {listing.detailTrip.highlight}
                    </span>
                    <br />
                    <br />
                    <span className="!whitespace-pre-wrap text-neutral-6000 dark:text-neutral-300">
                        {listing.detailTrip.description}
                    </span>
                    <br />
                    <br />
                    <div className="w-full block border-b border-neutral-100 mb-3 " />

                    {/* {listing.detailTrip.isOpenTrip ? <></> :
                        <div>
                            <div className="flex justify-between w-full">
                                <span className="flex-1">
                                    <h4 className="text-lg font-semibold">Additional Slot</h4>
                                    <span className="text-sm">
                                        {i18n.t('add_slot_desc', { number: listing.detailTrip.maxGuest })}
                                    </span>
                                </span>
                                <NcInputNumber
                                    className="w-min"
                                    defaultValue={addSlot}
                                    onChange={(value) => {
                                        setAddSlot(value);
                                    }}
                                    max={4}
                                />
                            </div>
                            <br />
                        </div>} */}
                    {/* <div className="hidden md:block py-4">
                        <div className=" mb-4">
                            <span className="text-md font-semibold">
                                {i18n.t('kids_text')}
                            </span>
                            <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                                <span className="flex-1">
                                    {i18n.t('under_two_year')}
                                </span>
                                <NcInputNumber
                                    className="w-min hidden md:block"
                                    defaultValue={bigLuggage}
                                    onChange={(value) => {
                                        setUnderTwoYears(value)
                                    }}
                                />
                            </div>
                            <div className="flex flex-row justify-between mb-2 w-full">
                                <span className="flex-1">
                                    {i18n.t('under_twelve')}
                                </span>
                                <NcInputNumber
                                    className="w-min hidden md:block"
                                    defaultValue={bigLuggage}
                                    onChange={(value) => {
                                        setUnderTwelve(value)
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-row justify-between mb-2 w-full">
                            <span className="flex-1">
                                {i18n.t('big_luggage')}
                            </span>
                            <NcInputNumber
                                className="w-min hidden md:block"
                                defaultValue={bigLuggage}
                                onChange={(value) => {
                                    setBigLuggage(value)
                                }}
                            />
                        </div>
                        <div className="flex flex-row justify-between mb-2 w-full">
                            <span className="flex-1">
                                {i18n.t('small_luggage')}
                            </span>
                            <NcInputNumber
                                className="w-min hidden md:block"
                                defaultValue={smallLuggage}
                                onChange={(value) => {
                                    setSmallLuggage(value)
                                }}
                            />
                        </div>
                    </div> */}
                    {/* <div className="mb-4">
                        <h4 className="text-lg font-semibold">Services</h4>
                        <div className="">
                            <ul className="mt-3 text-neutral-500 dark:text-neutral-400 space-y-2">

                                {listing.detailTrip?.productService.map((item: any, i: any) => {
                                    let service = item;
                                    return (
                                        <li key={i} className="flex flex-row justify-between mb-4 w-full">
                                            <span className="flex-1">
                                                {item.name}
                                            </span>
                                            <p className="text-sm font-semibold">
                                                {item.price == 0 ? 'Free' : currency(item.price)}
                                            </p>
                                            <NcInputNumber
                                                className="w-min hidden md:block"
                                                defaultValue={selectedServices[i] ? selectedServices[i].qty : 0}
                                                onChange={(value) => {
                                                    if (value >= 0) {
                                                        service.qty = value;
                                                        setSelectedServices({
                                                            ...selectedServices,
                                                            [`${i}`]: service
                                                        });
                                                    }
                                                }}
                                            // max={4}
                                            />
                                        </li>);
                                })}
                            </ul>
                        </div>
                    </div> */}

                    {/* {listing.detailTrip?.productLocation?.length > 0 &&
                        <div className="mt-6">
                            <h4 className="text-lg font-semibold">Places</h4>
                            <div className="">
                                <ul className="mt-3 text-neutral-500 dark:text-neutral-400 space-y-2">
                                    {listing.detailTrip?.productLocation.map((item: any, i: any) => {
                                        return (
                                            <li key={i} className="flex flex-row justify-between mb-4 w-full">
                                                <span className="flex-1">
                                                    {item.locationName}
                                                </span>
                                            </li>);
                                    })}
                                </ul>
                            </div>
                        </div>} */}
                </div>
            </div>
        );
    };


    const renderSidebar = () => {
        return (
            <div className="listingSection__wrap shadow-xl mb-4">
                <div className="flex justify-between">
                    <span className="text-3xl font-semibold">
                        {currency(listing.detailTrip.totalPrice)}
                        {listing.detailTrip.isOpenTrip ?
                            <></> :
                            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
                                /{i18n.t('day')}
                            </span>
                        }
                    </span>
                    {/* <StartRating /> */}
                </div>

                {/* FORM */}
                <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-2xl ">

                    {id == listing.detailTrip?.id && (
                        <StayDatesRangeInput
                            editable={!listing.detailTrip?.isOpenTrip}
                            wrapClassName="divide-x divide-neutral-200 dark:divide-neutral-700"
                            onChange={(date) => {
                                if (!listing.detailTrip?.isOpenTrip) {
                                    setSelectedDate(date);
                                }
                            }
                            }
                            minDate={(moment()).tz(listing.detailTrip.timezone)}
                            numberOfMonths={1}
                            fieldClassName="p-5"

                            defaultValue={listing.detailTrip?.isOpenTrip ? {
                                startDate: moment(listing.detailTrip?.startTripDate, 'MMMM D YYYY'),
                                endDate: moment(listing.detailTrip?.endTripDate, 'MMMM D YYYY')
                            } : selectedDate}
                            anchorDirection={windowSize.width > 1400 ? "left" : "right"}
                        />)}
                    <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
                    {/* {(!listing.detailTrip?.isOpenTrip && listing.detailTrip?.additionalSlotPrice > 0) || listing.detailTrip?.isOpenTrip &&
                        <GuestsInput
                            onChange={(value) => {
                                setAddSlot(value.guestAdults ?? 0);
                            }
                            }
                            fieldClassName={`p-5 ${getDays() < 1 && 'bg-gray-100'}`}
                            disabled={getDays() < 1}
                            defaultValue={{
                                guestAdults: addSlot,
                                perSlot: listing.detailTrip.maxGuest,
                                isOpenTrip: listing.detailTrip.isOpenTrip
                            }}

                        />} */}
                    {listing.detailTrip?.isOpenTrip ? (
                        <GuestsInput
                            onChange={(value) => {
                                setAddSlot(value.guestAdults ?? 0);
                            }
                            }
                            fieldClassName={`p-5 ${getDays() < 1 && 'bg-gray-100'}`}
                            disabled={getDays() < 1}
                            defaultValue={{
                                guestAdults: addSlot,
                                perSlot: listing.detailTrip.maxGuest,
                                isOpenTrip: listing.detailTrip.isOpenTrip
                            }}

                        />
                    ) : listing.detailTrip?.maxAddSlot > 0 && (
                        <GuestsInput
                            onChange={(value) => {
                                setAddSlot(value.guestAdults ?? 0);
                            }
                            }
                            max={listing.detailTrip?.maxAddSlot}
                            fieldClassName={`p-5 ${getDays() < 1 && 'bg-gray-100'}`}
                            disabled={getDays() < 1}
                            defaultValue={{
                                guestAdults: addSlot,
                                perSlot: listing.detailTrip.maxGuest,
                                isOpenTrip: listing.detailTrip.isOpenTrip
                            }}

                        />
                    )}

                    {/* {listing.detailTrip?.isOpenTrip === true ? (
                        <GuestsInput
                            onChange={(value) => {
                                setAddSlot(value.guestAdults ?? 0);
                            }
                            }
                            fieldClassName={`p-5 ${getDays() < 1 && 'bg-gray-100'}`}
                            disabled={getDays() < 1}
                            defaultValue={{
                                guestAdults: addSlot,
                                perSlot: listing.detailTrip.maxGuest,
                                isOpenTrip: listing.detailTrip.isOpenTrip
                            }}
                        />
                    ) : listing?.detailTrip?.addSlotPrice > 0 ? (
                        <GuestsInput
                            onChange={(value) => {
                                setAddSlot(value.guestAdults ?? 0);
                            }
                            }
                            fieldClassName={`p-5 ${getDays() < 1 && 'bg-gray-100'}`}
                            disabled={getDays() < 1}
                            defaultValue={{
                                guestAdults: addSlot,
                                perSlot: listing.detailTrip.maxGuest,
                                isOpenTrip: listing.detailTrip.isOpenTrip
                            }}

                        />
                    ) : <></>} */}

                </form>
                <div className={` ${getDays() < 1 ? 'hidden' : 'hidden md:block'}`}>
                    <div className={`mb-4 `}>
                        {/* <span className="text-md font-semibold">
                            {i18n.t('kids_text')}
                        </span> */}
                        <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                            <span className="flex-1">
                                {i18n.t('adult')}
                            </span>
                            <NcInputNumber
                                className="w-min hidden md:block"
                                defaultValue={adult}
                                max={maxAdult == 0 ? -1 : maxAdult}
                                onChange={(value) => {
                                    setAdult(value)
                                }}
                            />
                        </div>
                        <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                            <span className="flex-1">
                                {i18n.t('under_two_year')}
                            </span>
                            <NcInputNumber
                                className="w-min hidden md:block"
                                defaultValue={underTwoYears}
                                max={maxUnder == 0 ? -1 : maxUnder}
                                onChange={(value) => {
                                    setUnderTwoYears(value)
                                }}
                            />
                        </div>
                        <div className="flex flex-row justify-between mb-2 w-full">
                            <span className="flex-1">
                                {i18n.t('under_twelve')}
                            </span>
                            <NcInputNumber
                                className="w-min hidden md:block"
                                defaultValue={underTwelve}
                                max={maxTwelve == 0 ? -1 : maxTwelve}
                                onChange={(value) => {
                                    setUnderTwelve(value)
                                }}
                            />
                        </div>
                    </div>


                    <div className="flex flex-row justify-between mb-2 w-full">
                        <span className="flex-1">
                            {i18n.t('big_luggage')}
                        </span>
                        <NcInputNumber
                            className="w-min hidden md:block"
                            defaultValue={bigLuggage}
                            max={listing.detailTrip.isOpenTrip ? addSlot : guest}
                            onChange={(value) => {
                                setBigLuggage(value)
                            }}
                        />
                    </div>
                    <div className="flex flex-row justify-between mb-2 w-full">
                        <span className="flex-1">
                            {i18n.t('small_luggage')}
                        </span>
                        <NcInputNumber
                            className="w-min hidden md:block"
                            defaultValue={smallLuggage}
                            max={listing.detailTrip.isOpenTrip ? addSlot : guest}
                            onChange={(value) => {
                                setSmallLuggage(value)
                            }}
                        />
                    </div>
                </div>
                <div className="">
                    <h4 className="text-md font-semibold mb-4">Services</h4>
                    <ul className="space-y-2">
                        {listing.detailTrip?.productService.map((item: any, i: any) => {
                            let service = item;
                            return (
                                <li key={i} className="flex justify-between mb-4 w-full">
                                    <span className="flex-1 text-md">
                                        {item.name}
                                    </span>
                                    <NcInputNumber
                                        className="w-min"
                                        defaultValue={selectedServices[i] ? selectedServices[i].qty : 0}
                                        onChange={(value) => {
                                            if (value >= 0) {
                                                service.qty = value;
                                                setSelectedServices({
                                                    ...selectedServices,
                                                    [`${i}`]: service
                                                });
                                            }
                                        }}
                                    // max={4}
                                    />
                                </li>);
                        })}
                    </ul>
                </div>
                <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

                {/* SUM */}
                <div className="flex flex-col space-y-4">
                    <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                        <span>Trip fee</span>
                        <span>{currency(listing.detailTrip.totalPrice)}</span>
                    </div>
                    {addSlot > 0 &&
                        <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                            <span>{listing.detailTrip.isOpenTrip ? 'Pax' : 'Additional slot'}</span>
                            <span>{listing.detailTrip.isOpenTrip ? addSlot : addSlot + ` x ` + currency(listing.detailTrip.addSlotPrice == 0 ? listing.detailTrip.totalPrice : listing.detailTrip.addSlotPrice)}</span>
                        </div>
                    }
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                    <div className="flex justify-between font-semibold">
                        <span>Price</span>
                        <span>{currency(getBasicPrice().toFixed(2))}</span>
                    </div>
                    <div className="flex justify-between font-semibold">
                        <span>{t('long_trip')}</span>
                        <span>{getDays() + ` ` + i18n.t('day')}</span>
                    </div>
                    {Object.keys(selectedServices).length > 0 ?
                        Object.keys(selectedServices).map((item: any, i: number) => {
                            const service = selectedServices[item];
                            if (service.qty && service.qty > 0 && service.price > 0) {
                                const prc = service.qty * parseFloat(service.price);
                                const fee = service.qty * parseFloat(service.feeAmount);
                                addToDiscount(prc - fee);
                            }
                            return (
                                service.qty === 0 ? <div key={ncNanoId()}></div> :
                                    <div key={ncNanoId()} className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                                        <span>{service.name}</span>
                                        <span>{`${service.price == 0 ? 'free' : `${service.qty} x ${currency(service.price)}`}`}</span>
                                    </div>
                            );
                        })
                        : <></>
                    }
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                    <div className="flex justify-between font-semibold">
                        <span>Subtotal</span>
                        <span>{currency(getSubTotal())}</span>
                    </div>
                    {parseFloat(getServiceFee()) > 0 ?
                        <div className="flex justify-between font-semibold">
                            <span>Additional Services fee</span>
                            <span>{currency(getServiceFee())}</span>
                        </div>
                        : <></>}
                    {countriesReducer.commissionSetting != null ?
                        <div className="flex justify-between font-semibold">
                            <span>Platform fee</span>
                            <span>{currency(getFeePlatform())}</span>
                        </div> : <></>}
                    {getDiscount() !== '0.00' ? <div className="flex justify-between font-semibold">
                        <span>Discount</span>
                        <span>( {currency(getDiscount())} )</span>
                    </div> : <></>}
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

                    <div className="flex justify-between font-bold">
                        <span>Total</span>
                        <span>{currency(getFinalPrice())}</span>
                    </div>
                </div>

                {/* SUBMIT */}
                {user.credential === null || user.credential === LOGIN_FALSE
                    ?
                    <ButtonPrimary href="/login">Masuk untuk melanjutkan</ButtonPrimary>
                    : parseInt(user.credential.id) === listing.detailTrip.user.id ?
                        <ButtonPrimary href="/profile">Go to listing</ButtonPrimary>
                        :
                        <ButtonPrimary
                            className={`${getDays() < 1 && 'bg-gray-300'}`}
                            // disabled={true}
                            onClick={() => {

                                if (selectedDate.startDate === null || selectedDate.startDate === undefined || selectedDate.endDate === null || selectedDate.endDate === undefined || (listing.detailTrip.isOpenTrip && addSlot < 1)) {
                                    toast("Data not complete, date or number of pax");
                                } else {
                                    if (listing.detailTrip.isOpenTrip == false) {
                                        if ((adult + underTwelve + underTwoYears) != guest) {
                                            toast("Please check your member");
                                            return false;
                                        }
                                    }
                                    setConfirmationModal(true);
                                }
                            }
                            }>{i18n.t('reserve')}</ButtonPrimary>
                }
            </div>
        );
    };

    const renderFormMobil = () => {
        return (
            <div className="listingSection__wrap mb-8" >
                <div className="flex flex-col !space-y-4">

                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold line-clamp-2">
                        {listing.detailTrip.title ?? listing.detailTrip.highlight}
                    </h2>
                    <div className="flex justify-between items-center ">
                        <Badge
                            name={`${listing.detailTrip.isOpenTrip ? 'Open Trip' : 'Private Trip'}`}
                            color={`${listing.detailTrip.isOpenTrip ? 'primary' : 'blue'}`} />
                        {/* <LikeSaveBtns /> */}
                    </div>

                    <div className="flex items-center space-x-4">
                        {/* <StartRating />
                <span>·</span> */}
                        <span>
                            <i className="las la-map-marker-alt"></i>
                            <span className="ml-1"> {listing.detailTrip.meetingAddress ? cropAddress(listing.detailTrip.meetingAddress) : ''}</span>
                        </span>
                    </div>
                </div>

                {/* FORM */}
                <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-md ">
                    {id == listing.detailTrip?.id && (
                        <StayDatesRangeInput
                            editable={!listing.detailTrip?.isOpenTrip}
                            wrapClassName="divide-x divide-neutral-200 dark:divide-neutral-700"
                            onChange={(date) => {
                                if (((date.startDate?.format('Y-m-d') !== selectedDate.startDate?.format('Y-m-d') && date.endDate?.format('Y-m-d') !== selectedDate.endDate?.format('Y-m-d')) || date.endDate == null)) {
                                    setSelectedDate(date);
                                }
                            }
                            }
                            minDate={(moment()).tz(listing.detailTrip.timezone)}
                            numberOfMonths={1}
                            fieldClassName="p-5"

                            defaultValue={listing.detailTrip?.isOpenTrip ? {
                                startDate: moment(listing.detailTrip?.startTripDate, 'MMMM D YYYY'),
                                endDate: moment(listing.detailTrip?.endTripDate, 'MMMM D YYYY')
                            } : selectedDate}
                            anchorDirection={windowSize.width > 1400 ? "left" : "right"}
                        />)}
                    <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
                    <GuestsInput
                        onChange={(value) => setAddSlot(value.guestAdults ?? 0)}
                        fieldClassName={`p-5 !rounded-md ${getDays() < 1 && 'bg-gray-100'}`}
                        disabled={getDays() < 1}
                        defaultValue={{
                            guestAdults: addSlot,
                            perSlot: listing.detailTrip.maxGuest,
                            isOpenTrip: listing.detailTrip.isOpenTrip
                        }}

                    />
                    {/* {listing.detailTrip?.isOpenTrip === true ? (
                        <GuestsInput
                            onChange={(value) => {
                                setAddSlot(value.guestAdults ?? 0);
                            }
                            }
                            fieldClassName={`p-5 ${getDays() < 1 && 'bg-gray-100'}`}
                            disabled={getDays() < 1}
                            defaultValue={{
                                guestAdults: addSlot,
                                perSlot: listing.detailTrip.maxGuest,
                                isOpenTrip: listing.detailTrip.isOpenTrip
                            }}
                        />
                    ) : listing?.detailTrip?.addSlotPrice > 0 ? (
                        <GuestsInput
                            onChange={(value) => {
                                setAddSlot(value.guestAdults ?? 0);
                            }
                            }
                            fieldClassName={`p-5 ${getDays() < 1 && 'bg-gray-100'}`}
                            disabled={getDays() < 1}
                            defaultValue={{
                                guestAdults: addSlot,
                                perSlot: listing.detailTrip.maxGuest,
                                isOpenTrip: listing.detailTrip.isOpenTrip
                            }}

                        />
                    ) : <></>} */}
                </form>

                {/* SUM */}
                <div className="flex flex-col space-y-4">

                    <div>
                        <div className={` ${getDays() < 1 ? 'hidden' : 'block md:hidden'} py-4`}>
                            <div className=" mb-4">
                                {/* <span className="text-md font-semibold">
                                    {i18n.t('kids_text')}
                                </span> */}
                                <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                                    <span className="flex-1">
                                        {i18n.t('adult')}
                                    </span>
                                    <NcInputNumber
                                        className="w-min block md:hidden"
                                        defaultValue={adult}
                                        max={maxAdult == 0 ? -1 : maxAdult}
                                        onChange={(value) => {
                                            setAdult(value)
                                        }}
                                    />
                                </div>
                                <div className="flex flex-row justify-between mt-2 mb-2 w-full">
                                    <span className="flex-1">
                                        {i18n.t('under_two_year')}
                                    </span>
                                    <NcInputNumber
                                        className="w-min block md:hidden"
                                        defaultValue={underTwoYears}
                                        max={maxUnder == 0 ? -1 : maxUnder}
                                        onChange={(value) => {
                                            setUnderTwoYears(value)
                                        }}
                                    />
                                </div>
                                <div className="flex flex-row justify-between mb-2 w-full">
                                    <span className="flex-1">
                                        {i18n.t('under_twelve')}
                                    </span>
                                    <NcInputNumber
                                        className="w-min block md:hidden"
                                        defaultValue={underTwelve}
                                        max={maxTwelve == 0 ? -1 : maxTwelve}
                                        onChange={(value) => {
                                            setUnderTwelve(value)
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="flex flex-row justify-between mb-2 w-full">
                                <span className="flex-1">
                                    {i18n.t('big_luggage')}
                                </span>
                                <NcInputNumber
                                    className="w-min block md:hidden"
                                    defaultValue={bigLuggage}
                                    max={listing.detailTrip.isOpenTrip ? addSlot : guest}
                                    onChange={(value) => {
                                        setBigLuggage(value)
                                    }}
                                />
                            </div>
                            <div className="flex flex-row justify-between mb-2 w-full">
                                <span className="flex-1">
                                    {i18n.t('small_luggage')}
                                </span>
                                <NcInputNumber
                                    className="w-min block md:hidden"
                                    defaultValue={smallLuggage}
                                    max={listing.detailTrip.isOpenTrip ? addSlot : guest}
                                    onChange={(value) => {
                                        setSmallLuggage(value)
                                    }}
                                />
                            </div>
                        </div>

                        <h4 className="text-md font-semibold">Services</h4>
                        <div className="">
                            <ul className="mt-3 space-y-2">
                                {listing.detailTrip?.productService.map((item: any, i: any) => {
                                    let service = item;
                                    return (
                                        <li key={i} className="flex justify-between mb-4 w-full">
                                            <span className="flex-1 text-md">
                                                {item.name}
                                            </span>
                                            <NcInputNumber
                                                className="w-min"
                                                defaultValue={selectedServices[i] ? selectedServices[i].qty : 0}
                                                onChange={(value) => {
                                                    if (value >= 0) {
                                                        service.qty = value;
                                                        setSelectedServices({
                                                            ...selectedServices,
                                                            [`${i}`]: service
                                                        });
                                                    }
                                                }}
                                            // max={4}
                                            />
                                        </li>);
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                        <span>Trip fee</span>
                        <span>{currency(listing.detailTrip.totalPrice)}</span>
                    </div>
                    {addSlot > 0 ?
                        <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                            <span>{listing.detailTrip.isOpenTrip ? 'Pax' : 'Additional slot'}</span>
                            <span>{listing.detailTrip.isOpenTrip ? addSlot : addSlot + ` x ` + currency(listing.detailTrip.addSlotPrice)}</span>
                        </div> : <></>}
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                    <div className="flex justify-between font-semibold">
                        <span>Price</span>
                        <span>{currency(getBasicPrice())}</span>
                    </div>
                    <div className="flex justify-between font-semibold">
                        <span>{t('long_trip')}</span>
                        <span>{getDays() + ` ` + i18n.t('day')}</span>
                    </div>
                    {Object.keys(selectedServices).length > 0 ?
                        Object.keys(selectedServices).map((item: any, i: number) => {
                            const service = selectedServices[item];
                            if (service.qty && service.qty > 0 && service.price > 0) {
                                const prc = service.qty * parseFloat(service.price);
                                const fee = service.qty * parseFloat(service.feeAmount);
                                addToDiscount(prc - fee);
                            }
                            return (
                                service.qty === 0 ? <div key={ncNanoId()}></div> :
                                    <div key={ncNanoId()} className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                                        <span>{service.name}</span>
                                        <span>{`${service.price == 0 ? 'free' : `${service.qty} x ${currency(service.price)}`}`}</span>
                                    </div>
                            );
                        })
                        : <div key={ncNanoId()}></div>

                    }
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                    <div className="flex justify-between font-semibold">
                        <span>Subtotal</span>
                        <span>{currency(getSubTotal())}</span>
                    </div>
                    {parseFloat(getServiceFee()) > 0 ?
                        <div className="flex justify-between font-semibold">
                            <span>Additional Services fee</span>
                            <span>{currency(getServiceFee())}</span>
                        </div>
                        : <></>}
                    {countriesReducer.commissionSetting != null ?
                        <div className="flex justify-between font-semibold">
                            <span>Platform fee</span>
                            <span>{currency(getFeePlatform())}</span>
                        </div> : <></>}
                    {getDiscount() !== '0.00' ? <div className="flex justify-between font-semibold">
                        <span>Discount</span>
                        <span>( {currency(getDiscount())} )</span>
                    </div> : <></>}
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                    <div className="flex justify-between font-bold">
                        <span>Total</span>
                        <span>{currency(getFinalPrice())}</span>
                    </div>
                </div>
                <div className="fixed bottom-0 w-full left-0 z-10 ">
                    {user.credential === null || user.credential === LOGIN_FALSE
                        ?
                        <ButtonPrimary className="w-full !rounded-none" href="/login">Masuk untuk melanjutkan</ButtonPrimary>
                        : parseInt(user.credential.id) === listing.detailTrip.user.id ?
                            <ButtonPrimary className="w-full !rounded-none" href="/profile">Go to listing</ButtonPrimary>
                            :
                            <div className="flex flex-row gap-2">
                                <ButtonSecondary className={`w-full !rounded-none block md:hidden  `} onClick={() => setOpenFormMobile(false)}>Back</ButtonSecondary>
                                <ButtonPrimary className={`w-full !rounded-none block md:hidden ${getDays() < 1 && 'bg-gray-300'}`}
                                    onClick={() => {
                                        // if (selectedDate.startDate === null || selectedDate.startDate === undefined || selectedDate.endDate === null || selectedDate.endDate === undefined || (listing.detailTrip.isOpenTrip && addSlot < 1)) {

                                        if (getDays() < 1 || (listing.detailTrip.isOpenTrip && addSlot < 1)) {
                                            toast("Data not complete, date or number of pax", { position: toast.POSITION.TOP_CENTER });
                                        } else {
                                            if (listing.detailTrip.isOpenTrip == false) {
                                                if ((adult + underTwelve + underTwoYears) != guest) {
                                                    toast("Please check your member");
                                                    return false;
                                                }
                                            }
                                            setConfirmationModal(true)
                                        }
                                    }}>{listing.detailTrip.isOpenTrip ? 'Checkout' : 'Reserve'}</ButtonPrimary>

                            </div>
                    }
                </div>
            </div>
        );
    };


    return listing.detailTrip === null || (listing.detailTrip != null && listing.detailTrip.length == 0) ?
        <DetailSkeleton /> :
        (<div className={`nc-ListingStayDetailPage`} data-nc-id="ListingStayDetailPage">
            <>
                <ToastContainer position="bottom-right" />
                <header className={`${openFormMobile ? 'hidden md:block' : ''} container 2xl:px-14 rounded-md sm:rounded-xl`}>
                    <div className={`relative hidden md:block md:grid md:gap-2  ${listing.detailTrip.file.length > 1 ? 'md:grid-cols-3 xl:grid-cols-4 ' : `md:grid-cols-${listing.detailTrip.file.length}`} `}>
                        <div
                            className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
                            onClick={() => handleOpenModal(0)}
                        >
                            <NcImage
                                containerClassName={`${listing.detailTrip.file.length > 1 ? 'absolute inset-0' : ' h-96'}`}
                                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                                src={listing.detailTrip.file[0] ? getUrl(listing.detailTrip.file[0].urls[4]) : ''}
                                prevImageHorizontal
                            />
                            <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
                        </div>

                        {listing.detailTrip.file.filter((_: any, i: any) => i >= 1 && i < 5).map((item: any, index: any) => (
                            <div key={index} className={`relative rounded-md sm:rounded-xl overflow-hidden ${index >= 3 ? "hidden sm:block" : ""}`}>
                                <NcImage
                                    containerClassName="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5"
                                    className="object-cover w-full h-full rounded-md sm:rounded-xl "
                                    src={getUrl(item.urls[4])}
                                    prevImageHorizontal
                                />
                                <div
                                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                                    onClick={() => handleOpenModal(index + 1)}
                                />
                            </div>
                        ))}

                        < div
                            className="absolute  md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
                            onClick={() => handleOpenModal(0)}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                                />
                            </svg>
                            <span className="ml-2 text-neutral-800 text-sm font-medium">
                                Show all photos
                            </span>
                        </div>
                    </div>
                    <div className={` flex flex-col md:hidden`}>
                        <div
                            className="relative rounded-md overflow-hidden cursor-pointer h-64 w-full"
                            onClick={() => handleOpenModal(0)}
                        >
                            <NcImage
                                containerClassName={`${listing.detailTrip.file.length > 1 ? 'absolute inset-0' : ' h-96'}`}
                                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                                src={listing.detailTrip.file[0] ? getUrl(listing.detailTrip.file[0].urls[4]) : ''}
                                prevImageHorizontal
                            />
                        </div>
                        <div className="grid grid-cols-4 gap-2 mt-2">
                            {listing.detailTrip.file.filter((_: any, i: any) => i >= 1 && i < 5).map((item: any, index: any) => (
                                <div key={index} className={`relative rounded-md overflow-hidden `}>
                                    <NcImage
                                        containerClassName="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5"
                                        className="object-cover w-full h-full rounded-md sm:rounded-xl "
                                        src={getUrl(item.urls[4])}
                                        prevImageHorizontal
                                    />
                                    {listing.detailTrip.file.length > 5 && index === 3 ?
                                        <div
                                            className="absolute inset-0 bg-black bg-opacity-50 transition-opacity cursor-pointer justify-center item-center w-full flex flex-col"
                                            onClick={() => handleOpenModal(0)}
                                        >
                                            <p className="text-white text-xs text-center">
                                                Show all
                                            </p>
                                        </div>
                                        :
                                        <div
                                            className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                                            onClick={() => handleOpenModal(index + 1)}
                                        />
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </header>
                <ModalPhotos
                    imgs={listing.detailTrip.file}
                    isOpen={isOpen}
                    onClose={handleCloseModal}
                    initFocus={openFocusIndex}
                />
            </>
            <main className="container  flex-col ">
                <div className="flex flex-row">
                    <div className={`${openFormMobile ? 'hidden md:block' : ''}  w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10`}>
                        <DetailRenderSection1 trip={listing.detailTrip} reserve={() => setOpenFormMobile(true)} />
                        {renderSection2()}
                        <RenderThingsToKnow trip={listing.detailTrip} />
                        <div className="space-y-8 lg:space-y-10"></div>
                    </div>
                    <div className="sticky hidden md:block flex-grow mt-10 ">{renderSidebar()}</div>
                    <div className={`${openFormMobile ? 'block md:hidden' : 'hidden'}  w-full`}>
                        {renderFormMobil()}
                    </div>
                </div>
                <div className={`${openFormMobile ? 'hidden md:block' : ''}`}>
                    {getLoadingQuestion() ? (
                        <div className="flex justify-center align-middle" style={{ height: '50%' }}>
                            <Loader
                                type="Circles"
                                color="rgb(210, 77, 41)"
                                height={25}
                                width={25}
                            />
                        </div>
                    ) : questionReducer.questionTrip ? (
                        <Questions count={questionReducer.questionTripCount} trip={listing.detailTrip} items={questionReducer} id={id} openModal={() => setopenQuestion(true)} user={user} textQues={getTextQuestion()} />
                    ) : (
                        <div className="flex justify-center mb-10">
                            <Loader
                                type="Circles"
                                color="#F3D2C9"
                                height={100}
                                width={100}
                            />
                        </div>
                    )}
                </div>

                {/* <QuestionsModal item={questionReducer.questionTrip} id={id} user={user}/> */}
                <div className={`${openFormMobile ? 'hidden md:block' : ''}`}>
                    <OthersListing trips={listing.OthersOnDetailTrip} />
                </div>

                <Modal
                    closeButton={() => setPaymentMethodModal(false)}
                    children={() => (
                        <div className="flex flex-col w-2/3 p-4 mx-auto rounded-lg drop-shadow bg-white">
                            <span className=" text-neutral-900 dark:text-neutral-200 font-semibold">
                                Metode Pembayaran
                            </span>
                            <span className=" text-sm text-neutral-900 dark:text-neutral-200 font-regular">
                                Manual transfer akan memerlukan konfirmasi kamu ke team kami melalui whatsapp
                            </span>
                            <div className="flex flex-col w-full mt-8 space-4">
                                <ButtonSecondary onClick={goWithTransfer} className="w-full p-2 h-min">
                                    {submitting ?
                                        <Loader
                                            type="Circles"
                                            color="text-color-6000"
                                            height={25}
                                            width={25}
                                        /> : 'Manual Transfer'}
                                </ButtonSecondary>
                                <ButtonPrimary onClick={() => {
                                    setStripeOptions({
                                        clientSecret: result.paymentIntent
                                    });
                                    setPaymentMethodModal(false);
                                    setOpenStripe(true);

                                }} className=" w-full h-min p-2 mt-4 ">
                                    {submitting ?
                                        <Loader
                                            type="Circles"
                                            color="white"
                                            height={25}
                                            width={25}
                                        /> : 'Kartu kredit'}
                                </ButtonPrimary>
                            </div>
                        </div>
                    )}
                    isOpen={paymentMethodModal}
                />

                <NcModal
                    isOpenProp={openStripe}
                    renderTrigger={() => <></>}
                    renderContent={() => (
                        stripePromise ? (
                            <Elements stripe={stripePromise}
                                options={stripeOptions}
                            >
                                <CheckOutForm
                                    data={result}
                                    clientSecret={clientSecret} />
                            </Elements>
                        ) : <></>
                    )}
                    onCloseModal={() => setOpenStripe(false)}
                    modalTitle={'Stripe Secure Payment (PCI-DSS)'}
                />

                <NcModal
                    isOpenProp={confimationModal}
                    renderTrigger={() => { return (<div></div>); }}
                    hideCloseBtn={true}
                    // contentExtraClass="w-1/4"
                    modalTitle={t('confirmation')}
                    renderContent={() => {
                        return (
                            <div className="">
                                <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-medium">
                                    {t('this_process_cannot_be_undone')}
                                </span>
                                <br />
                                <div className="flex flex-col" style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                    <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                        <input
                                            style={{ position: 'relative', top: 5 }}
                                            className="mr-2"
                                            name="isGoing"
                                            type="checkbox"
                                            checked={isTerm}
                                            onChange={() => setIsTerm(!isTerm)} />
                                        <div className="text-left">I have read and agree to the <a href="/term-and-condition" target={"_blank"} className="text-primary-6000">Terms and Conditions</a> of Guidesantai</div>
                                    </label>
                                    <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                        <input
                                            style={{ position: 'relative', top: 5 }}
                                            className="mr-2"
                                            name="isGoing"
                                            type="checkbox"
                                            checked={isCancel}
                                            onChange={() => setisCancel(!isCancel)} />
                                        <div className="text-left">I have read and agree to the <a href="/cancelation-policy" target={"_blank"} className="text-primary-6000">Cancelation Policy</a> of Guidesantai</div>
                                    </label>
                                </div>

                                <div className="flex flex-row w-full mt-8 space-x-4">
                                    <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                    <ButtonPrimary disabled={isCancel && isTerm ? false : true} onClick={reserve} className="flex-1 w-full h-min p-2 ">
                                        {submitting ?
                                            <Loader
                                                type="Circles"
                                                color="white"
                                                height={25}
                                                width={25}
                                            /> : 'Yes'}
                                    </ButtonPrimary>
                                </div>
                            </div>
                        )
                    }}
                />

                {/* <Modal
                    children={() => (
                        <div className="flex flex-col w-2/3 p-8 mx-auto rounded-lg  bg-white">
                            <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-medium">
                                {t('this_process_cannot_be_undone')}
                            </span>
                            <br />
                            <div className="flex flex-col" style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                    <input
                                        style={{ position: 'relative', top: 5 }}
                                        className="mr-2"
                                        name="isGoing"
                                        type="checkbox"
                                        checked={isTerm}
                                        onChange={() => setIsTerm(!isTerm)} />
                                    <div className="text-left">I have read and agree to the <a href="/term-and-condition" target={"_blank"} className="text-primary-6000">Terms and Conditions</a> of Guidesantai</div>
                                </label>
                                <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                    <input
                                        style={{ position: 'relative', top: 5 }}
                                        className="mr-2"
                                        name="isGoing"
                                        type="checkbox"
                                        checked={isCancel}
                                        onChange={() => setisCancel(!isCancel)} />
                                    <div className="text-left">I have read and agree to the <a href="/cancelation-policy" target={"_blank"} className="text-primary-6000">Cancelation Policy</a> of Guidesantai</div>
                                </label>
                            </div>

                            <div className="flex flex-row w-full mt-8 space-x-4">
                                <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                <ButtonPrimary disabled={isCancel && isTerm ? false : true} onClick={reserve} className="flex-1 w-full h-min p-2 ">
                                    {submitting ?
                                        <Loader
                                            type="Circles"
                                            color="white"
                                            height={25}
                                            width={25}
                                        /> : 'Yes'}
                                </ButtonPrimary>
                            </div>
                        </div>
                    )}
                    isOpen={confimationModal}
                /> */}








            </main>

        </div >);
}
export default ListingDetail;


export const CheckOutForm: FC<{ data: any, clientSecret: string }> = ({ data, clientSecret }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [submitting, setSubmitting] = useState(false);
    const [elementOnLoad, setElementOnLoad] = useState(true);

    const isSecureEnv = typeof window !== 'undefined' ? (window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') : true;

    const stripePaymentHandle = async (event: any) => {
        event.preventDefault();
        if (submitting || !stripe || !elements) {
            return;
        }
        setSubmitting(true);
        try {
            const result = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: `${process.env.REACT_APP_BASE_URL || window.location.origin + '/'}booking-detail?id=${data.id}`,
                },
            });
            setSubmitting(false);
            if (result.error) {
                toast.warn(result.error.message);
            } else {
                window.location.reload();
            }
        } catch (err: any) {
            setSubmitting(false);
            toast.error(err.message || 'Payment processing error');
        }
    }

    return (
        <form onSubmit={stripePaymentHandle} className="space-y-4">
            {!isSecureEnv && (
                <div className="p-3 text-xs bg-yellow-50 text-yellow-800 rounded-md border border-yellow-200">
                    ⚠️ Warning: Insecure connection detected. Payment must be processed over HTTPS to comply with PCI-DSS requirements.
                </div>
            )}

            {/* PCI-DSS SAQ A Compliance Notice Badge */}
            <div className="flex items-center space-x-2 p-2.5 bg-gray-50 dark:bg-neutral-800 rounded-lg text-xs text-gray-600 dark:text-neutral-300 border border-gray-200 dark:border-neutral-700">
                <svg className="w-4 h-4 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span>🔒 <b>256-Bit SSL Encrypted</b> · PCI-DSS SAQ A Compliant via Stripe iFrame</span>
            </div>

            <PaymentElement
                id="payment-element"
                options={{
                    layout: 'tabs',
                }}
                onReady={() => {
                    setElementOnLoad(false);
                }} />

            {elementOnLoad ? (
                <div className="flex justify-center p-4">
                    <Loader
                        type="Circles"
                        color="rgb(210, 77, 41)"
                        height={25}
                        width={25}
                    />
                </div>
            ) : (
                <ButtonPrimary
                    disabled={!stripe || submitting}
                    className="w-full mt-4">
                    {submitting ?
                        <Loader
                            type="Circles"
                            color="white"
                            height={25}
                            width={25}
                        /> : 'Pay Now Securely'}
                </ButtonPrimary>
            )}
        </form>
    );
}

export const OthersListing: FC<{ trips: any[] }> = ({ trips }) => {
    return (
        trips == null || trips?.length < 1 ? <></> :
            <div className="flex flex-col space-y-2 my-4 ">

                <h4 className="py-2 mt-2 text-sm md:text-md  md:text-lg text-left font-semibold">
                    {i18n.t('also_covering')}
                </h4>
                <div className="flex flex-row w-full overflow-x-auto">
                    {trips?.map((item: any) => {
                        return (
                            <OtherTripCard item={item} key={ncNanoId()} />
                        );
                    })}
                </div>
            </div>
    );
}


export const Questions: FC<{ items: any, openModal?: any, user: any, id: any, textQues?: any, count: any, trip: any }> = ({ items, openModal, id, user, textQues, count, trip }) => {

    const [text, setText] = React.useState<String>('');
    const [loadingAnswer, setLoadingAnswer] = React.useState(false);
    const [openModalConfirmationDelete, setOpenModalConfirmationDelete] = React.useState<string | null>(null);
    const [idAnswerQuestion, setidAnswerQuestion] = useState<number | null>(null);
    const dispatch = useDispatch();
    const [showButton, setShowButton] = useState(null)
    const [startPage] = useState<number | null>(0);
    const { t } = useTranslation();
    const [pageActive, setPageActive] = useState('0');
    const [, setpageShow] = useState<number | null>(0);
    const [ShowMore, setShowMore] = useState<any | null>([]);
    const [openConfirmQuestion, setopenConfirmQuestion] = React.useState<string | null>(null);
    const [loadingQuestion, setloadingQuestion] = React.useState(false);
    let item = items.questionTrip;
    let answerUser = items.answerUser;





    const hardReeset = () => {
        var aa = document.querySelectorAll('textarea');
        aa.forEach(val => {
            val.value = "";
        })
    }
    const deleteAnswer = async () => {
        setLoadingAnswer(true);
        let result = await authGet('auth/answer/delete/' + idAnswerQuestion);
        if (openModalConfirmationDelete === `${"question"}`) {
            result = await authGet('auth/questions/delete/' + idAnswerQuestion);
        }
        if (result.code == 200) {
            dispatch(getQuestionTrip(id, pageActive));
            dispatch(getAnswerUser(id))
            setOpenModalConfirmationDelete(null);
            setLoadingAnswer(false);
        }
    }

    // const deleteQuestion = async (idQuestion:any) => {
    //     console.log(question);

    //     if (question.code == 200) {
    //         dispatch(getQuestionTrip(id));
    //     }
    // }

    // useEffect(() => {
    // if (item) {
    updateShowItem(getShowItem() < item.length ? item.length : getShowItem());
    // }

    // })


    const sendAnswer = async (idQuestion: any, page: any) => {
        setLoadingAnswer(true);
        var data = {
            question: idQuestion,
            text: text
        }

        var send = await authJsonPost(
            data,
            'auth/answer-post'
        )

        if (send.code === 200) {
            setText('');
            updateTextQuestion('');

            dispatch(getQuestionTrip(id, pageActive))
            dispatch(getAnswerUser(id))
            setText('');
            hardReeset();
        }

        setLoadingAnswer(false);
    }


    const Paginate = (count: any) => {
        return Array.from(Array(Math.round(count)), (e, i) => {
            return (<a href="#!">{i}</a>)
        });
    }

    const sendQuestion = async () => {

        setloadingQuestion(true);
        var data = {
            product: id,
            text: text
        }


        var send = await authJsonPost(
            data,
            'auth/question-post'
        )


        if (send.code === 200) {
            setopenConfirmQuestion(null);
            updateTextQuestion('');
            dispatch(getQuestionTrip(id, 0));
            dispatch(getAnswerUser(id))
            hardReeset();
            setPageActive('0');
            setpageShow(0);
        }
        setloadingQuestion(false);

    }

    const followQuestion = async (idQuestion: any) => {
        let data = {
            id: idQuestion
        }
        var follow = await authJsonPost(
            data,
            'auth/questions/follow'
        )

        if (follow.code === 200) {
            dispatch(getAnswerUser(id))
        }
    }

    const findUser = (id: any) => {
        return answerUser.find((x: any) => x.id == id)
    }



    const DropDownUser = (val: any) => {
        let data = [];
        //  data = [
        //     {id:'1', name:`${t('delete')} ${t('question')}`, icon:""},
        // ]

        if (user.credential.id == val.uid) {
            data.push({ id: '1', name: `${t('delete')} ${t('question')}`, icon: "" });
        }

        if (findUser(val.id) != undefined) {
            if (findUser(val.id).follow == 1) {
                data.push({ id: '2', name: 'Unfollow Question', icon: "" });
            } else {
                data.push({ id: '2', name: 'Follow Question', icon: "" });
            }
        }
        return data;
    }


    return (
        <div className="mb-4">
            <div className="listingSection__wrap">
                <h2 className="text-lg md:text-2xl font-semibold">Questions</h2>

                {item != 0 ? item.map((val: any, index: any) => {

                    return (
                        <div key={val.id}>
                            <div className="flex justify-between" style={{ marginTop: 10, alignItems: 'flex-end' }}>
                                <div className="flex w-full">
                                    <Avatar
                                        sizeClass="h-10 w-10 text-lg"
                                        radius="rounded-full"
                                        userName="img"
                                        imgUrl={val.avatar}
                                    />
                                    <div className="ml-2 flex-1">
                                        <div className="flex align-middle" style={{ alignItems: 'center' }}>
                                            <h4 style={{ fontSize: 16 }} className="mr-2 font-semibold" >{val.displayName}</h4>
                                            <h5 style={{ fontSize: 12 }}>{`${toHumanDate(val.created)}`}</h5>

                                            {user?.credential?.id ? DropDownUser(val).length > 0 ? (
                                                <div className="flex-1 ">
                                                    <div className="flex-row " style={{ textAlign: 'right' }}>
                                                        <NcDropDown data={DropDownUser(val)} onClick={(item) => {
                                                            if (item.id === '1') {
                                                                setidAnswerQuestion(val.id);
                                                                setOpenModalConfirmationDelete(`${t("question")}`);
                                                            } else {
                                                                followQuestion(val.id)
                                                            }
                                                        }} />
                                                    </div>
                                                </div>)
                                                : <div key={val.id}></div> : <div key={val.id}></div>}
                                        </div>
                                        <label style={{ whiteSpace: 'pre-line', lineBreak: 'anywhere' }}>{val.text}</label>
                                        <div className="my-2"></div>
                                        <div className="bg-neutral-100 p-2" style={{ borderRadius: '10px' }}>
                                            {/* {val.answer.length > 0 ? ( */}
                                            <div>
                                                {val['0'].answer.map((ans: any, ians: any) => {

                                                    return (
                                                        ians < 1 ? (
                                                            <div key={ans.id} className="flex  w-full mb-3">
                                                                <Avatar
                                                                    sizeClass="h-10 w-10 text-lg"
                                                                    radius="rounded-full"
                                                                    userName="A"
                                                                    imgUrl={ans.avatar ? ans.avatar : ""}
                                                                />
                                                                <div className="grid ml-2">
                                                                    <div className="flex align-middle" style={{ alignItems: 'center' }}>
                                                                        <h4 style={{ fontSize: 16 }} className="mr-2 font-semibold" >{ans.displayName ? ans.displayName : "Admin"}</h4>
                                                                        {trip.user.id == ans.uid ? (
                                                                            <div className="mr-2"><Badge name="Guide" /></div>
                                                                        ) : ans.displayName == null ? (
                                                                            <div className="mr-2"><Badge name="Admin" color="pink" /></div>
                                                                        ) : <></>}
                                                                        <h5 style={{ fontSize: 12 }}>{`${toHumanDate(ans.created)}`}</h5>

                                                                    </div>
                                                                    <p style={{ marginTop: 2, whiteSpace: 'pre-line', lineBreak: 'anywhere' }}>{ans.text}</p>
                                                                </div>
                                                                <div className="flex-1 ">
                                                                    <div className="flex-row " style={{ textAlign: 'right' }}>
                                                                        {user?.credential?.id == ans.uid ? (
                                                                            <NcDropDown data={[{ id: '1', name: `${t('delete')} ${t('answer')}`, icon: "" }]} onClick={(item) => {
                                                                                // deleteAnswer(ans.id);
                                                                                setidAnswerQuestion(ans.id);
                                                                                setOpenModalConfirmationDelete(`${t("answer")}`);
                                                                            }} />
                                                                        ) : <div key={ans.id}></div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) :
                                                            <div key={ncNanoId()}></div>
                                                    )
                                                }
                                                )}

                                                <div style={{ display: ShowMore['key' + val.id] && ShowMore['key' + val.id] == 'on' ? 'block' : 'none' }}>
                                                    {val['0'].answer.map((ans: any, ians: any) => {

                                                        return (
                                                            ians > 0 ? (
                                                                <div key={ans.id} className="flex  w-full mb-3">
                                                                    <Avatar
                                                                        sizeClass="h-10 w-10 text-lg"
                                                                        radius="rounded-full"
                                                                        userName="A"
                                                                        imgUrl={ans.avatar ? ans.avatar : ""}
                                                                    />
                                                                    <div className="grid ml-2">
                                                                        <div className="flex align-middle" style={{ alignItems: 'center' }}>
                                                                            <h4 style={{ fontSize: 16 }} className="mr-2 font-semibold" >{ans.displayName ? ans.displayName : "Admin"}</h4>
                                                                            {trip.user.id == ans.uid ? (
                                                                                <div className="mr-2"><Badge name="Guide" /></div>
                                                                            ) : ans.displayName == null ? (
                                                                                <div className="mr-2"><Badge name="Admin" color="pink" /></div>
                                                                            ) : <></>}
                                                                            <h5 style={{ fontSize: 12 }}>{`${toHumanDate(ans.created)}`}</h5>
                                                                        </div>
                                                                        <p style={{ marginTop: 2, whiteSpace: 'pre-line', lineBreak: 'anywhere' }}>{ans.text}</p>
                                                                    </div>
                                                                    <div className="flex-1 ">
                                                                        <div className="flex-row " style={{ textAlign: 'right' }}>
                                                                            {user?.credential?.id == ans.uid ? (
                                                                                <NcDropDown data={[{ id: '1', name: `${t('delete')} ${t('answer')}`, icon: "" }]} onClick={(item) => {
                                                                                    // deleteAnswer(ans.id);
                                                                                    setidAnswerQuestion(ans.id);
                                                                                    setOpenModalConfirmationDelete(`${t("answer")}`);
                                                                                }} />
                                                                            ) : <></>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) :
                                                                <div key={ncNanoId()}></div>

                                                        )
                                                    }
                                                    )}
                                                </div>
                                                <div style={{ display: val['0'].answer.length > 1 ? 'block' : 'none' }} ><a className="cursor-pointer" onClick={() => {
                                                    if (ShowMore['key' + val.id] == 'on') {
                                                        setShowMore({ ['key' + val.id]: 'off' });
                                                    } else {
                                                        setShowMore({ ['key' + val.id]: 'on' });
                                                    }
                                                }}>{ShowMore['key' + val.id] == 'on' ? 'Less more' : `show more (${val['0'].answer.length - 1})`}</a></div>


                                            </div>

                                            <div>
                                                <ReactTextareaAutosize key={index} onFocus={() => {
                                                    setShowButton(index);

                                                }} onChange={(e) => setText(e.target.value)} placeholder="Type your answer" minRows={showButton === index ? 3 : 1} className="block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 mb-2" />
                                                {showButton === index ? user?.credential?.id ? (
                                                    <div className="flex justify-end">
                                                        <ButtonSecondary className="mr-2" onClick={() => {
                                                            hardReeset();
                                                            setShowButton(null);
                                                        }}>Cancel</ButtonSecondary>
                                                        <ButtonPrimary className="mt-0" onClick={() => {
                                                            if (text == '') {
                                                            } else {
                                                                updateTextQuestion(text.toString());

                                                                sendAnswer(val.id, startPage);
                                                            }
                                                        }}>{loadingAnswer ? <Loader
                                                            type="Circles"
                                                            color="white"
                                                            height={25}
                                                            width={25}
                                                        /> : 'Send'}</ButtonPrimary>
                                                    </div>
                                                ) : <div className="flex justify-end"> <ButtonPrimary href="/login">{t('signInToSend')} {t('answer')}</ButtonPrimary></div> : <></>}
                                            </div>
                                            {/* ) : <></>} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border-b border-neutral-200 dark:border-neutral-700 mt-4"></div>
                        </div>
                    )
                }) : <></>}
                <div className="flex overflow-x-auto px-3 md:justify-center" style={{ gap: 10 }} >
                    {item.length > 0 ? count > 0 && Array.from(Array(Math.ceil(count / getShowItem())), (e, i) => {
                        return <a key={i} onClick={() => {
                            dispatch(getQuestionTrip(id, i));
                            setPageActive(`${i}`);
                            setpageShow(i * 10);

                        }} className={`border px-3 rounded-full inline-flex items-center justify-center cursor-pointer  ${parseInt(pageActive) == i ? 'bg-primary-6000 text-neutral-50' : ''}`}   >{i + 1}</a>
                    }) : <></>}

                </div>
                {user?.credential?.id ? (
                    <div>
                        <ReactTextareaAutosize defaultValue={textQues} onChange={(e) => setText(e.target.value)} placeholder="Type your question" minRows={3} className="block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900" />
                        <ButtonPrimary className="mt-2 w-full" onClick={() => {
                            if (text == '') {
                            } else {
                                updateTextQuestion(text.toString());
                                setopenConfirmQuestion('question');
                            }
                        }}>Send</ButtonPrimary>
                    </div>
                ) : <ButtonPrimary href="/login">{t('signInToSend')} {t('question')}</ButtonPrimary>}
            </div>
            <NcModal
                isOpenProp={openModalConfirmationDelete != null}
                renderTrigger={() => { return (<div></div>); }}
                modalTitle={'Question'}
                renderContent={() => (
                    <div>
                        <label>{t('conf_delete')} {openModalConfirmationDelete} ?</label>
                        <div className="flex justify-between">
                            <ButtonSecondary onClick={() => {
                                setLoadingAnswer(false);
                                setOpenModalConfirmationDelete(null)
                            }}>No</ButtonSecondary>
                            <ButtonPrimary onClick={deleteAnswer} >{loadingAnswer ?
                                <Loader
                                    type="Circles"
                                    color="white"
                                    height={25}
                                    width={25} /> : 'Yes'}</ButtonPrimary>
                        </div>
                    </div>
                )}
                onCloseModal={() => {
                    setLoadingAnswer(false);
                    setOpenModalConfirmationDelete(null)
                }}
            />

            <NcModal
                isOpenProp={openConfirmQuestion !== null}
                renderTrigger={() => { return (<div></div>); }}
                modalTitle={'Question'}
                // contentExtraClass = "w-full"
                renderContent={() => (
                    <div>
                        <label>Are you sure want to send {openConfirmQuestion} ?</label>
                        <div className="flex justify-between">
                            <ButtonSecondary onClick={() => setopenConfirmQuestion(null)}>No</ButtonSecondary>
                            <ButtonPrimary onClick={sendQuestion}>{loadingQuestion ?
                                <Loader
                                    type="Circles"
                                    color="white"
                                    height={25}
                                    width={25} /> : 'Yes'}</ButtonPrimary>
                        </div>
                    </div>
                )}
                onCloseModal={() => setopenConfirmQuestion(null)}
            />

        </div>
    )
}




export const RenderThingsToKnow: FC<{ trip: any }> = ({ trip }) => {
    const [activeDoc, setActiveDoc] = useState('');
    const [activeDoctitle, setActiveDocTitle] = useState('');
    const [isDocOpen, setIsDocOpen] = React.useState(false);

    return (
        <>
            <DocIframe
                title={activeDoctitle}
                baseDoc={activeDoc}
                isOpen={isDocOpen}
                onClose={() => setIsDocOpen(false)}
                initFocus={0}
            />
            <div className="listingSection__wrap">
                <h2 className="text-lg md:text-2xl font-semibold">Things to know</h2>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />
                {/* <button onClick={() => {
                    setActiveDocTitle(i18n.t('gov_rest'));
                    setActiveDoc(`uploads/pdf/travel_doc_${trip.country.countryCode}`);
                    setIsDocOpen(true);
                }
                } className="flex flex-row justify-between mb-4">
                    <div className="flex-1">
                        <h4 className="text-md md:text-lg text-left font-semibold">{i18n.t('gov_rest')}</h4>
                    </div>
                    <i className="la la-chevron-right" />
                </button> */}
                <button onClick={() => {
                    setActiveDocTitle(i18n.t('res_ref'));
                    // setActiveDoc(`uploads/pdf/cancel_doc_${trip.country.countryCode}`);
                    setActiveDoc('legal/cancelation-policy');
                    setIsDocOpen(true);
                }} className="flex flex-row justify-between mb-4">
                    <div className="flex-1">
                        <h4 className="text-md md:text-lg text-left font-semibold">{i18n.t('res_ref')}</h4>
                    </div>
                    <i className="la la-chevron-right" />
                </button>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />
            </div>
        </>
    );
};

export const DetailRenderSection1: FC<{ trip: any, reserve?: any, reserveTitle?: any }> = ({ trip, reserve, reserveTitle }) => {

    const location = () => {
        let string = trip?.title || '';
        if (trip?.productLocation && Array.isArray(trip.productLocation)) {
            trip.productLocation.forEach((v: any) => {
                if (v?.locationName) {
                    string = string + " - " + v.locationName;
                }
            });
        }
        return string;
    }

    const title = trip?.title ?? trip?.highlight ?? 'GuideSantai';
    const pageTitle = `${title} | GuideSantai`;
    const cleanDescription = (trip?.description || location() || 'Jelajahi destinasi terbaik bersama GuideSantai.').replace(/<[^>]*>?/gm, '').trim();
    const mainImage = trip?.file && trip.file[0] && trip.file[0].urls ? getUrl(trip.file[0].urls[4] || trip.file[0].urls[0]) : 'https://guidesantai.com/logo512.png';
    const currentUrl = typeof window !== 'undefined' ? window.location.href : `https://guidesantai.com/detail?q=${trip?.slug || ''}`;

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "TouristTrip",
        "name": title,
        "description": cleanDescription,
        "image": mainImage,
        "touristType": trip?.isOpenTrip ? "Open Trip" : "Private Trip",
        "offers": {
            "@type": "Offer",
            "price": trip?.price || trip?.adultPrice || 0,
            "priceCurrency": "IDR",
            "availability": "https://schema.org/InStock",
            "url": currentUrl
        },
        "provider": {
            "@type": "Organization",
            "name": "GuideSantai",
            "url": "https://guidesantai.com"
        }
    };

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{pageTitle}</title>
                <meta name="description" content={cleanDescription} />
                <link rel="canonical" href={currentUrl} />

                {/* Open Graph / Facebook / WhatsApp */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content={currentUrl} />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={cleanDescription} />
                <meta property="og:image" content={mainImage} />
                <meta property="og:site_name" content="GuideSantai" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content={currentUrl} />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={cleanDescription} />
                <meta name="twitter:image" content={mainImage} />

                {/* Structured Data (JSON-LD) for Google Rich Results */}
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>
            <div className="block md:hidden fixed bottom-0 left-0    z-10 w-full flex flex-row justify-center">
                <ButtonPrimary onClick={reserve} className="w-full !rounded-none">
                    <span>{reserveTitle ?? 'Check Availability'}</span>
                </ButtonPrimary>
            </div>
            <div className="listingSection__wrap !space-y-6">


                <div className="flex justify-between items-center">
                    <Badge
                        name={`${trip.isOpenTrip ? 'Open Trip' : 'Private Trip'}`}
                        color={`${trip.isOpenTrip ? 'primary' : 'blue'}`} />
                    {/* <LikeSaveBtns /> */}
                </div>

                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold line-clamp-2">
                    {trip.title ?? trip.highlight}
                </h2>

                <div className="flex items-center space-x-4">
                    {/* <StartRating />
                <span>·</span> */}
                    <span>
                        <i className="las la-map-marker-alt"></i>
                        <span className="ml-1 text-neutral-700 text-sm"> {trip.meetingAddress ? cropAddress(trip.meetingAddress) : 'Ask to guide'}</span>
                    </span>
                </div>
                <div className="flex flex-col md:flex-row md:justify-between">
                    <div className="flex items-center">
                        <Avatar imgUrl={trip.user.profile.avatar} hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
                        <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-medium">
                            {trip.user.profile.displayName}
                        </span>
                    </div>
                    {/* <Link
                        to={{ pathname: `https://play.google.com/store/apps/details?id=com.guidesantai` }}
                        target={`_blank`}
                        className="flex flex-row space-x-2 items-center mt-4 mb-4 md:mt-0 bg-primary-6000 bg-opacity-20 rounded-md py-1 px-2">
                        <ChatAlt2Icon className="h-8 w-8 text-primary-6000 " />
                        <span className="text-md font-medium">Chat</span>
                    </Link> */}
                </div>


                <div className="w-full hidden md:block border-b border-neutral-100 " />

                <div className="flex flex-col space-y-4 md:!space-y-0 md:flex-row md:items-center md:justify-between xl:justify-start md:space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
                    <div className="flex items-center space-x-3 ">
                        <i className=" las la-user text-2xl "></i>
                        <span className="">
                            {trip.maxGuest} <span className="">{trip.isOpenTrip ? 'Max Guests' : 'Guests included'}</span>
                        </span>
                    </div>
                    <div className="flex items-center space-x-3">
                        <i className=" las la-map-marker-alt text-2xl"></i>
                        <span className=" ">
                            {trip.productLocation.length} <span className="">place(s) {trip.isOpenTrip ? 'to visit' : 'recommended'}</span>
                        </span>
                    </div>
                    <div className="flex items-center space-x-3">
                        <i className=" las la-user-friends text-2xl"></i>
                        <span className="">Additional slot available</span>
                    </div>

                </div>
                <div className="w-full block border-b border-neutral-100 " />
                <div className="flex gap-2  flex-wrap">
                    {trip.productLocation.length > 0 && trip.productLocation.map((v: any, k: any) => {
                        return (
                            <Badge color="green" key={k} name={v.locationName} />
                        )
                    })}
                </div>
            </div>
        </>
    );
};